import numWord from '../../../utils/numWord';
import { useTranslation } from '../../../translations';

export const useToDaysLongHoursLongOrHHMMSS = () => {
  const { t } = useTranslation();

  return ({
    milliseconds,
    daysArray = [t('other.days.0.text'), t('other.days.1.text'), t('other.days.2.text')],
    hoursArray = [t('other.hours.0.text'), t('other.hours.1.text'), t('other.hours.2.text')],
    DaysLongHoursLongSplitterInsidePart = ' ',
    DaysLongHoursLongSplitterBetweenParts = ', ',
    HHMMSSSplitter = ':',
  }) => {
    const MS_IN_SECOND = 1000;
    const MS_IN_MINUTE = 60 * MS_IN_SECOND;
    const MS_IN_HOUR = 60 * MS_IN_MINUTE;
    const MS_IN_DAY = 24 * MS_IN_HOUR;

    if (milliseconds >= MS_IN_DAY) {
      const days = Math.floor(milliseconds / MS_IN_DAY);
      const remainingMs = milliseconds % MS_IN_DAY;
      const hours = Math.floor(remainingMs / MS_IN_HOUR);

      const daysText = `${days}${DaysLongHoursLongSplitterInsidePart}${numWord(days, daysArray)}`;

      if (hours > 0) {
        const hoursText = `${hours} ${numWord(hours, hoursArray)}`;
        return `${daysText}${DaysLongHoursLongSplitterBetweenParts}${hoursText}`;
      }

      return daysText;
    } else {
      const hours = Math.floor(milliseconds / MS_IN_HOUR);
      const remainingAfterHours = milliseconds % MS_IN_HOUR;
      const minutes = Math.floor(remainingAfterHours / MS_IN_MINUTE);
      const remainingAfterMinutes = remainingAfterHours % MS_IN_MINUTE;
      const seconds = Math.floor(remainingAfterMinutes / MS_IN_SECOND);

      return `${String(hours).padStart(2, '0')}${HHMMSSSplitter}${String(minutes).padStart(
        2,
        '0',
      )}${HHMMSSSplitter}${String(seconds).padStart(2, '0')}`;
    }
  };
};
